"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SimServiceItem;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _ErrorMessage = _interopRequireDefault(require("./blocks/ErrorMessage"));
var _ToggleSwitch = _interopRequireDefault(require("./blocks/ToggleSwitch"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4; // @ts-ignore: Unreachable code error
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n"])));
var IconDiv = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 8px;\n"])));
var DetailsDiv = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 14px 10px 0 21px;\n"])));
var ToggleDiv = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n"])));
function SimServiceItem(props) {
  var barNumber = props.barNumber,
    iconName = props.iconName,
    serviceTitle = props.serviceTitle,
    barStatus = props.barStatus,
    error = props.error,
    handleStatusChange = props.handleStatusChange;
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(MainContainer, null, /*#__PURE__*/_react.default.createElement(IconDiv, {
    "data-testid": "barring-management-service-icon-".concat(barNumber)
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: iconName,
    group: "system",
    size: 5
  })), /*#__PURE__*/_react.default.createElement(DetailsDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "barring-management-service-title-".concat(barNumber)
  }, serviceTitle)), barStatus && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Pill, {
    text: t('barred'),
    state: "error"
  })), error && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, null))), /*#__PURE__*/_react.default.createElement(ToggleDiv, null, /*#__PURE__*/_react.default.createElement(_ToggleSwitch.default, {
    barNumber: barNumber,
    active: barStatus,
    onchange: function onchange() {
      handleStatusChange(barNumber, barStatus);
    }
  })));
}